import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

const CommonFaderStyles = css`
  position: absolute;
  width: ${({ biggerFadding }) => (biggerFadding ? "44px" : "18px")};
  z-index: 20;
  ${(props) =>
    props.centerFaders
      ? css`
          top: 5%;
          height: 90%;
        `
      : css`
          top: 0;
          height: 100%;
        `};
  pointer-events: none;
`;

export const ScrollWrapperContainer = styled.div`
  position: relative;
  overflow-x: ${({ isFullWidth }) => (isFullWidth ? "hidden" : "auto")};
  ${(props) => (props.isForcingMinWidth ? "min-width: 100%;" : "width: 100%")};
  z-index: ${(props) => props.zIndex || (props.showFaders ? 1 : 0)};
  ${(props) =>
    props.showFaders &&
    css`
      ${props.hasContentLeft &&
      css`
        &::before {
          content: "";
          left: 0;
          background-image: linear-gradient(
            to left,
            ${props.fadeFrom},
            ${props.fadeTo}
          );
          ${CommonFaderStyles};
        }
      `};
      ${props.hasContentRight &&
      css`
        &::after {
          content: "";
          right: 0;
          background-image: linear-gradient(
            to right,
            ${props.fadeFrom},
            ${props.fadeTo}
          );
          ${CommonFaderStyles};
        }
      `};
    `};
  ${({ hasBottomShadow, hasBottomBorder }) =>
    (hasBottomShadow || hasBottomBorder) &&
    css`
      box-shadow: ${hasBottomShadow
        ? "0 2px 4px rbga(0, 0, 0, 0.1)"
        : `0 1px 0 0 ${buildColor("grey", "L2")}`};
    `};
  ${({ isSticky, noTopSpace }) =>
    isSticky &&
    css`
      position: sticky;
      top: ${noTopSpace ? "0" : "60px"};
    `};
`;

export default ScrollWrapperContainer;
